// Lib
import { createStructuredSelector, createSelector } from 'reselect';

// Util
import { createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { getMany } from '../../../../../common/utils/immutableHelper';

// Selector
import { boardVisibleElementGraphSelector } from '../../../../element/selectors/elementGraphSelector';
import { getCurrentUserQuickNotesRootBoardId } from '../../../../user/currentUserSelector';
import { getElements } from '../../../../element/selectors/elementsSelector';

// Types
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import { getLocationParentId } from '../../../../../common/elements/utils/elementPropertyUtils';

const getQuickNotesBoard = createSelector(
    getElements,
    getCurrentUserQuickNotesRootBoardId,
    (elements, quickNotesRootId): ImMNElement => elements.get(quickNotesRootId),
);

export const quickNotesElementSelector = createStructuredSelector({
    element: getQuickNotesBoard,
    elementId: getCurrentUserQuickNotesRootBoardId,
    quickNotesRootId: getCurrentUserQuickNotesRootBoardId,
});

export const isElementInQuickNotesSelector = createSelector(
    getElements,
    (_: any, { elementId }: { elementId: string }) => elementId,
    getCurrentUserQuickNotesRootBoardId,
    (elements, elementId, quickNotesRootId): boolean =>
        getLocationParentId(elements.get(elementId)) === quickNotesRootId,
);

/**
 * The visible elements within quick notes.
 */
export const getQuickNotesElementIdsDeep = createShallowSelector(
    boardVisibleElementGraphSelector,
    getCurrentUserQuickNotesRootBoardId,
    (visibleElementGraph, quickNotesBoardId) => visibleElementGraph[quickNotesBoardId] || [],
);

export const getQuickNotesElementsDeep = createShallowSelector(getQuickNotesElementIdsDeep, getElements, getMany);
